// src/pages/ConfirmBooking.js
import { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../../utils/axios';
import { useAuth } from '../../context/AuthContext';

const ConfirmBooking = () => {
  const { bookingId } = useParams();
  const [status, setStatus] = useState('');
  const navigate = useNavigate();
  const { user } = useAuth();
console.log(user);
  const handleConfirm = async () => {
    try {
      await api.put(`/api/car-bookings/${bookingId}/confirm`);
      setStatus('confirmed');
      alert('Successfully confirmed as a passenger.');
      navigate('/bookings');
    } catch (err) {
      console.error(err);
      alert(err.response?.data?.error || 'Failed to confirm.');
    }
  };

  return (
    <div className="container mt-5">
      <h2>Passenger Confirmation:</h2>
      <h2 className='text-info'>{user.name}</h2>
      <p>Click below to confirm your participation in this booking.</p>
      <button className="btn btn-success" onClick={handleConfirm} disabled={status === 'confirmed'}>
        {status === 'confirmed' ? 'Confirmed ✅' : 'Confirm'}
      </button>
    </div>
  );
};

export default ConfirmBooking;
